import { render, staticRenderFns } from "./InvoiceTemplateUploadDialog.vue?vue&type=template&id=0bce36c0&"
import script from "./InvoiceTemplateUploadDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplateUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTemplateUploadDialog.vue?vue&type=style&index=0&id=0bce36c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports